import { render, staticRenderFns } from "./signup-service.vue?vue&type=template&id=dc70d360&scoped=true&"
import script from "./signup-service.vue?vue&type=script&lang=js&"
export * from "./signup-service.vue?vue&type=script&lang=js&"
import style0 from "./signup-service.vue?vue&type=style&index=0&id=dc70d360&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc70d360",
  null
  
)

export default component.exports